export default __webpack_public_path__ + "static/media/10.49062ca3.JPG";